import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../../chunks/tslib.es6.js";
import t from "../../core/Evented.js";
import { abortMaybe as s, isSome as i, isNone as r, unwrapOr as n } from "../../core/maybe.js";
import { createTask as o } from "../../core/promiseUtils.js";
import { createScreenPointArray as a } from "../../core/screenUtils.js";
import { property as p } from "../../core/accessorSupport/decorators/property.js";
import "../../core/arrayUtils.js";
import "../../core/has.js";
import "../../core/accessorSupport/ensureType.js";
import { subclass as h } from "../../core/accessorSupport/decorators/subclass.js";
import d from "../../layers/GraphicsLayer.js";
import { makeDehydratedPoint as c } from "../../layers/graphics/dehydratedFeatures.js";
import { SnappingVisualizer2D as l } from "../2d/interactive/SnappingVisualizer2D.js";
import { createCoordinateHelper as m } from "../interactive/coordinateHelper.js";
import { EditGeometry as y, Component as _ } from "../interactive/editGeometry/EditGeometry.js";
import { EditGeometryOperations as u } from "../interactive/editGeometry/EditGeometryOperations.js";
import { SnappingContext as g } from "../interactive/snapping/SnappingContext.js";

var _v;

var f = _v = /*#__PURE__*/function (_t$EventedAccessor) {
  _inherits(v, _t$EventedAccessor);

  var _super = _createSuper(v);

  function v(e) {
    var _this;

    _classCallCheck(this, v);

    var t;
    _this = _super.call(this, e), _this._hasZ = null, _this._cursorScreenPoint = null, _this._snappingTask = null, _this._stagedVertex = null, _this._stagedVertexUnsnapped = null, _this._lastVertexUnsnapped = null, _this._nativeEventHistory = {
      undoStack: [],
      redoStack: []
    }, _this.interactiveUndoDisabled = !1, _this.history = [], _this.redoHistory = [], _this.snapToScene = !1, _this.view = null, _this.elevationInfo = null, _this.defaultZ = 0, _this._coordinateHelper = m(e.hasZ, !1, e.view.spatialReference), _this._snappingManager = e.snappingManager, _this._editGeometryOperations = new u(new y(null != (t = e.editGeometryType) ? t : "polygon", _this._coordinateHelper, 2)), _this._snappingGraphicsLayer = new d({
      id: _v.SNAPPING_GRAPHICS_LAYER_ID,
      listMode: "hide",
      internal: !0
    }), _this._snappingContext = new g({
      editGeometryOperations: _this._editGeometryOperations,
      elevationInfo: {
        mode: "on-the-ground",
        offset: 0
      },
      pointer: "mouse",
      visualizer: new l(_this._snappingGraphicsLayer)
    }), _this._activeComponent = new _(e.view.spatialReference, 2), _this._editGeometryOperations.data.components.push(_this._activeComponent);
    return _this;
  }

  _createClass(v, [{
    key: "initialize",
    value: function initialize() {
      "2d" === this.view.type && this.view.map.layers.add(this._snappingGraphicsLayer);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this._snappingTask = s(this._snappingTask), this.view.map.layers.remove(this._snappingGraphicsLayer), this._snappingGraphicsLayer.destroy(), i(this._snappingManager) && this._snappingManager.doneSnapping(), this._editGeometryOperations.destroy();
    }
  }, {
    key: "_committedVertices",
    get: function get() {
      return this._editGeometryOperations.data.components[0].vertices.map(function (e) {
        return e.pos;
      });
    }
  }, {
    key: "vertices",
    get: function get() {
      return i(this._stagedVertex) ? [].concat(_toConsumableArray(this._committedVertices), [this._coordinateHelper.pointToArray(this._stagedVertex)]) : this._committedVertices;
    }
  }, {
    key: "hasZ",
    get: function get() {
      return i(this._hasZ) ? this._hasZ : "3d" === this.view.type;
    },
    set: function set(e) {
      this._hasZ = e, this.notifyChange("hasZ");
    }
  }, {
    key: "canUndo",
    value: function canUndo() {
      return this._editGeometryOperations.canUndo;
    }
  }, {
    key: "canRedo",
    value: function canRedo() {
      return this._editGeometryOperations.canRedo;
    }
  }, {
    key: "undo",
    value: function undo() {
      this.canUndo && this._editGeometryOperations.undo();
    }
  }, {
    key: "redo",
    value: function redo() {
      this.canRedo && this._editGeometryOperations.redo();
    }
  }, {
    key: "getCoordsFromScreenPoint",
    value: function getCoordsFromScreenPoint(e) {
      var t = this.screenToMap(e);
      return i(t) ? t.hasZ ? [t.x, t.y, t.z] : [t.x, t.y] : null;
    }
  }, {
    key: "getCoordsAndPointFromScreenPoint",
    value: function getCoordsAndPointFromScreenPoint(e) {
      var t = this.screenToMap(e);
      return i(t) ? t.hasZ ? {
        vertex: [t.x, t.y, t.z],
        mapPoint: t
      } : {
        vertex: [t.x, t.y],
        mapPoint: t
      } : null;
    }
  }, {
    key: "_pushCursorVertex",
    value: function _pushCursorVertex(e) {
      var _this2 = this;

      var t = c(e[0], e[1], null, this.view.spatialReference);
      this._stagedVertexUnsnapped = t, r(this._snappingManager) ? this._stagedVertex = t : (this._stagedVertex = this._snappingManager.update(t, this._snappingContext), this._snappingTask = o( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
          var _s;

          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!i(_this2._snappingManager)) {
                    _context.next = 5;
                    break;
                  }

                  _context.next = 3;
                  return _this2._snappingManager.snap(t, _this2._snappingContext, e);

                case 3:
                  _s = _context.sent;
                  return _context.abrupt("return", (_s.valid && (_this2._stagedVertex = _s.apply(), _this2.notifyChange("vertices")), _s));

                case 5:
                  return _context.abrupt("return", null);

                case 6:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }()));
    }
  }, {
    key: "_popCursorVertex",
    value: function _popCursorVertex() {
      this._stagedVertex = null, this._stagedVertexUnsnapped = null, this.notifyChange("vertices");
    }
  }, {
    key: "getGeometryZValue",
    value: function getGeometryZValue() {
      return this.defaultZ;
    }
  }, {
    key: "screenToMap",
    value: function screenToMap(e) {
      var t = null;
      if ("3d" === this.view.type) {
        if (this.hasZ) {
          var _s2 = n(this.elevationInfo, x);

          t = this.view.sceneIntersectionHelper.intersectElevationFromScreen(a(e.x, e.y), _s2, this.getGeometryZValue());
        } else {
          var _s3 = n(this.elevationInfo, G);

          t = this.view.sceneIntersectionHelper.intersectElevationFromScreen(a(e.x, e.y), _s3, 0), i(t) && (t.z = void 0);
        }
      } else t = this.view.toMap(e), i(t) && (t.z = this.hasZ ? this.getGeometryZValue() : void 0);
      return t;
    }
  }, {
    key: "_isDuplicateOfLastVertex",
    value: function _isDuplicateOfLastVertex(e) {
      var t = this._editGeometryOperations.data.components[0].getLastVertex();

      if (i(t) && e[0] === t[0] && e[1] === t[1]) return !0;

      var _this$_coordinateHelp = this._coordinateHelper.vectorToDehydratedPoint(e),
          s = _this$_coordinateHelp.x,
          r = _this$_coordinateHelp.y;

      return !(!i(this._lastVertexUnsnapped) || s !== this._lastVertexUnsnapped.x || r !== this._lastVertexUnsnapped.y);
    }
  }, {
    key: "_vertexAddHandler",
    value: function _vertexAddHandler(e) {
      var t = i(this._stagedVertex) ? this._coordinateHelper.pointToArray(this._stagedVertex) : this.getCoordsFromScreenPoint(this._cursorScreenPoint);
      i(t) && this._addVertex(t, e.native);
    }
  }, {
    key: "_drawCompleteHandler",
    value: function _drawCompleteHandler(e) {
      this._completeDrawing(e.native);
    }
  }]);

  return v;
}(t.EventedAccessor);

f.SNAPPING_GRAPHICS_LAYER_ID = "DrawAction-snapping-graphics-layer", e([p({
  readOnly: !0
})], f.prototype, "vertices", null), e([p({
  type: Boolean,
  nonNullable: !0
})], f.prototype, "interactiveUndoDisabled", void 0), e([p({
  readOnly: !0
})], f.prototype, "history", void 0), e([p({
  readOnly: !0
})], f.prototype, "redoHistory", void 0), e([p()], f.prototype, "snapToScene", void 0), e([p()], f.prototype, "view", void 0), e([p()], f.prototype, "elevationInfo", void 0), e([p({
  nonNullable: !0
})], f.prototype, "defaultZ", void 0), e([p()], f.prototype, "hasZ", null), f = _v = e([h("esri.views.draw.DrawAction")], f);
var x = {
  mode: "absolute-height",
  offset: 0
},
    G = {
  mode: "on-the-ground",
  offset: 0
},
    V = f;
export { V as default };